/* istanbul ignore file */
import { SectionRow } from 'framework/ui/layout';
import React from 'react';
import { TextField } from 'framework/ui/field';
import useMetricsHelper from 'domain/finance/costAccounting/shared/metricsHelper';
import { CircularProgressWithLabel } from 'framework/ui/mui-builder';
import Box from '@mui/material/Box';

interface MappingMetricsProps {
  current: number;
  expected: number;
  measurementName: string;
}

const MappingMetrics = ({ current, expected, measurementName }: MappingMetricsProps) => {
  const { calculatePercentage, calculateReversePercentage, subtractNumbers } = useMetricsHelper();
  const data = {
    mappedCount: current,
    mappedPercentage: calculatePercentage(current, expected, 1),
    unmappedCount: subtractNumbers(expected, current),
    unmappedPercentage: calculateReversePercentage(current, expected, 1),
    totalCount: expected,
  };

  return (
    <Box
      sx={theme => ({
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          display: 'flex',
          alignItems: 'flex-start',
        },
      })}
    >
      <CircularProgressWithLabel
        value={data.mappedPercentage}
        getColorFunc={value => {
          if (value < 95) return 'error';
          if (value < 99) return 'warning';
          return 'success';
        }}
      />
      <Box sx={{ flexGrow: 1 }}>
        <SectionRow>
          <TextField label={`Mapped ${measurementName}`} value={data.mappedCount} />
          <TextField label={`Mapped ${measurementName}, %`} value={data.mappedPercentage} />
        </SectionRow>
        <SectionRow>
          <TextField label={`Unmapped ${measurementName}`} value={data.unmappedCount} />
          <TextField label={`Unmapped ${measurementName}, %`} value={data.unmappedPercentage} />
        </SectionRow>
        <SectionRow>
          <TextField label={`Total ${measurementName}`} value={data.totalCount} />
        </SectionRow>
      </Box>
    </Box>
  );
};

export default MappingMetrics;
